export const sectionRoutes = {
  "/menu": "explore-menu",
  "/restaurants": "restaurant-showcase",
  "/mobile-app": "app-download",
  "/contact": "footer",
  "/contact-us": "footer",
};
